/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { toolsList } from "../funcs/toolsList.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListToolsResult } from "../models/components/listtoolsresult.js";
import {
  ListToolsRequest,
  ListToolsSecurity,
} from "../models/operations/listtools.js";
import { unwrapAsync } from "../types/fp.js";

export class Tools extends ClientSDK {
  /**
   * listTools tools
   *
   * @remarks
   * List all tools for a project
   */
  async list(
    request?: ListToolsRequest | undefined,
    security?: ListToolsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListToolsResult> {
    return unwrapAsync(toolsList(
      this,
      request,
      security,
      options,
    ));
  }
}
